// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"146c772e","563":"a1619918","787":"a1aa4d62"}[chunkId] + ".chunk.js";
};